import CSS from "./styles.module.css";
import AwardImg from "../../assets/images/promotions/G2 High Performer Fall 2023.png";
import HeartIcon from "../../assets/images/heart-svgrepo-com.svg";

function Promotions() {
	return (
		<div className={CSS.PromotionsContainer}>
			<div className={CSS.Promotions}>
				<div className={CSS.Tag}>
					Get
					<div className={CSS.Text}>
						<h3>50%</h3>
						Off
					</div>
				</div>
				<div className={CSS.ContentContainer}>
					<div className={CSS.Content}>
						<div className={CSS.Left}>
							<p>Upgrade Your</p>
							<h3>Hiring Game with Recooty</h3>
							<p>
								Get your loved ATS for the whole year at an unbelievable price{" "}
								<img src={HeartIcon} alt="TeamRecooty" />
							</p>
						</div>
						{/* <div className={CSS.Right}>
                        <img src={PromoImg} alt="Black Friday Sale 2023 - Offer valid for limited period only." />
                    </div> */}
					</div>
					<div className={CSS.Award}>
						<img src={AwardImg} alt="G2 High Performer Fall 2023" />
						<img
							src="https://recooty.com/images/badges/g2-most-recommended-23.png"
							alt="G2 Most Recommended Award 2023"
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Promotions;
